(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("common-gaspard"));
	else if(typeof define === 'function' && define.amd)
		define(["gaspard"], factory);
	else if(typeof exports === 'object')
		exports["common-vue-gaspard"] = factory(require("common-gaspard"));
	else
		root["VueGaspard"] = factory(root["Gaspard"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition